import {Logger} from '@vanti/vue-logger';

const log = Logger.get('loading');

export default {
  namespaced: true,
  getters: {
    appLoaded(state, getters, rootState, rootGetters) {
      // firebase auth is loaded
      const firebaseAuthLoaded = rootGetters['auth/authLoaded'];
      // firebase user config is loaded
      const userConfigLoaded = rootGetters['config/configLoaded'];

      log.info('loading state', {
        firebaseAuthLoaded,
        userConfigLoaded
      });

      return firebaseAuthLoaded && userConfigLoaded;
    }
  }
};
